import React from 'react';
import _ from 'lodash';
import * as PropTypes from "prop-types";

export default function RestoreHiddenItems({hiddenItems, restoreAllItems}) {
  if (_.isEmpty(hiddenItems))
    return null;

  return <div className="restore-removed">
    <a onClick={restoreAllItems}>
      Restore {hiddenItems.length} removed {' '}
      {hiddenItems.length == 1 ? "item" : "items"}
    </a>
  </div>

}

RestoreHiddenItems.propTypes = {
  hiddenItems: PropTypes.any,
  callbacks: PropTypes.any
}

